import { DataAnalytics, DataObject } from './common';
var PromoCenterDataType;
(function (PromoCenterDataType) {
    PromoCenterDataType["promos"] = "promos";
    PromoCenterDataType["promotions"] = "promotions";
    PromoCenterDataType["promoTermDetails"] = "promo-term-details";
})(PromoCenterDataType || (PromoCenterDataType = {}));
var PromoCenterDataReason;
(function (PromoCenterDataReason) {
    PromoCenterDataReason["promosTab"] = "promos-tab";
    PromoCenterDataReason["promos"] = "promos";
    PromoCenterDataReason["leftNav"] = "left nav";
    PromoCenterDataReason["headerNav"] = "header-nav";
})(PromoCenterDataReason || (PromoCenterDataReason = {}));
export var getPromoCenterAnalyticsProps = function (toggle) {
    return {
        tab: {
            'data-analytics': DataAnalytics.clickTrackingEvent,
            'data-object': toggle ? DataObject.expand : DataObject.collapse,
            'data-reason': PromoCenterDataReason.promosTab,
            'data-type': PromoCenterDataType.promos
        },
        accordion: {
            'data-analytics': DataAnalytics.clickTrackingEvent,
            'data-object': toggle ? DataObject.expand : DataObject.collapse,
            'data-reason': PromoCenterDataReason.promos,
            'data-type': PromoCenterDataType.promoTermDetails
        },
        leftNav: {
            'data-analytics': DataAnalytics.clickTrackingEvent,
            'data-object': DataObject.button,
            'data-reason': PromoCenterDataReason.leftNav,
            'data-type': PromoCenterDataType.promotions
        },
        headerNav: {
            'data-analytics': DataAnalytics.clickTrackingEvent,
            'data-object': DataObject.button,
            'data-reason': PromoCenterDataReason.headerNav,
            'data-type': PromoCenterDataType.promotions
        }
    };
};
//# sourceMappingURL=promo-center.js.map